
<div class="row" *ngIf="organization">
    <div class="col-7">
        
        <div class="card-header">
            <div class="title">{{ 'ORGANIZATION.ORGANIZATION_PROFILE' | translate }}</div>
            <div class="tools">
                <!-- <button type="button" class="btn btn-primary btn-sm"  routerLink="/organizations">
                    <i class="bi bi-arrow-left-square"></i>{{ 'BACK' | translate }}
                </button> -->
            </div>
        </div>

        <div class="card">



            <div class="background-img">
                <img *ngIf="!organization.background_pic" src="/assets/images/no_images_2000x510px.png" class="org-background" alt="background image">
                <img *ngIf="organization.background_pic"  src="{{ organization.background_pic }}"  alt="logo">
            </div>
            <div class="logo-img">
                <img *ngIf="!organization.logo_pic" src="/assets/images/no_logo_500x500px.png" alt="logo">
                <img *ngIf="organization.logo_pic"  src="{{ organization.logo_pic }}"  alt="logo">
            </div>
            
            <div class="card-body">
                
                <div class="first-line-of-attrs">
                    <div class="org-name">{{ organization.name }}</div>
                    <div class="org-btn-edit">
                        <a routerLink="/organizations/edit/{{ organization.id }}">
                            <i class="bi bi-pencil-square"></i> {{ 'EDIT' | translate }}
                        </a>
                    </div>
                </div>

                <div class="second-line-of-attrs">
                    <div class="org-info">
                        <div class="org-info-sub-title">{{ 'ROLE' | translate }}</div>
                        <div class="org-info-value">{{ organization.orole.name }}</div>
                    </div>
                    <div class="org-info">
                        <div class="org-info-sub-title">{{ 'ORGANIZATION.BIN' | translate }}</div>
                        <div class="org-info-value">{{ organization.ident_num }}</div>
                    </div>

                    <div *ngIf="organization.addresses != null">
                        <div class="org-info-title">{{ 'ADDRESS.ADDRESSES' | translate }}</div>
                        <div *ngFor="let address of organization.addresses">
                            <div class="org-info">
                                <div class="org-info-sub-title">
                                    <span *ngIf="address.address_type == 'legal'"> {{ 'ADDRESS.LEGAL_ADDRES' | translate }}</span>
                                    <span *ngIf="address.address_type == 'actual'">{{ 'ADDRESS.ACTUAL_ADDRES' | translate }}</span>
                                </div>
                                <div class="org-info-value">{{ addressObjToString(address) }}</div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="isEmptyObject(organization.banks)">
                        <div class="org-info-title">{{ 'ORGANIZATION.BANK_DETAILS' | translate }}</div>
                        <div *ngFor="let bank of organization.banks">
                            <div class="org-info">
                                <div class="org-info-sub-title">{{ 'ORGANIZATION.BANK' | translate }}</div>
                                <div class="org-info-value">{{ bank.name }}</div>
                            </div>
                            <div class="org-info">
                                <div class="org-info-sub-title">{{ 'ORGANIZATION.BTS' | translate }}</div>
                                <div class="org-info-value">{{ bank.bic }}</div>
                            </div>
                            <div class="org-info">
                                <div class="org-info-sub-title">{{ 'ORGANIZATION.IID' | translate }}</div>
                                <div class="org-info-value">{{ bank.account }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="org-info-title">{{ 'ORGANIZATION.VAT' | translate }}</div>
                        <div class="org-info">
                            <div class="org-info-sub-title">{{ 'ORGANIZATION.VAT_PAYER' | translate }}</div>
                            <div class="org-info-value">{{ organization.vat_payer.name }}</div>
                        </div>
                        <div class="org-info">
                            <div class="org-info-sub-title">{{ 'ORGANIZATION.VAT_SERIES' | translate }}</div>
                            <div class="org-info-value">{{ organization.vat_payer.seria }}</div>
                        </div>
                        <div class="org-info">
                            <div class="org-info-sub-title">{{ 'ORGANIZATION.VAT_NUMBER' | translate }}</div>
                            <div class="org-info-value">{{ organization.vat_payer.number }}</div>
                        </div>
                        <div class="org-info">
                            <div class="org-info-sub-title">{{ 'DATE' | translate }}</div>
                            <div class="org-info-value">{{ organization.vat_payer.date }}</div>
                        </div>


                </div>

            </div>
            <div class="card-footer">
                <div class="footer-tools">
                    <button type="button" class="btn btn-light btn-sm btn-back"  routerLink="/organizations">
                        <!-- <i class="bi bi-arrow-left-square mr-1"></i> -->
                        {{ 'BACK' | translate }}
                    </button>
                </div>
            </div>
        </div>

    </div>
    <div class="col-5">
  
        <!-- <div class="card">
            <div class="card-header">Контакты</div>
            <div class="card-body">
            </div>
        </div> -->

        <!-- <div class="card">
            <div class="card-header">Подразделения</div>
            <div class="card-body">
            </div>
        </div> -->

        <!-- <div class="card">
            <div class="card-header">Сотрудники</div>
            <div class="card-body">

                

            </div>
        </div> -->

        <app-organization-employees [data]="tableData"></app-organization-employees>

    </div>
</div>

<div *ngIf="!organization">
    <div *ngIf="loading"> {{ 'LOADING' | translate }}</div>
    <div *ngIf="!loading">{{ 'DATA_NOT_FOUND' | translate }}</div>
</div>